//Check if an item contains a specific product
export const itemContainsProduct = (item, productId) => {
  // Always check the main item first
  if (item.product_id === productId) {
    return true;
  }

  // Only check child items for specific product types
  if (isKitItem(item)) {
    return item.child_items.some(child => child.product_id === productId);
  }

  return false;
};

export const isKitItem = ( item) => {
  return item?.product_type === 'individual' || item?.product_type === 'depends' && item?.child_items?.length > 0;
};

//Calculate tote-specific counts
export const getToteSpecificCounts = currentTote => {
  if (!currentTote) {
    return {placedInCurrentTote: 0, totalAssignedToCurrentTote: 0};
  }

  const placedInCurrentTote = currentTote.item_pieces 
    ? currentTote.item_pieces.filter(piece => piece.status === 'picked_and_placed').length 
    : 0;

  return {
    placedInCurrentTote,
    totalAssignedToCurrentTote: currentTote.item_qty || 0
  };
};

//Calculate product-wide scanned counts across all totes
export const getProductWideScannedCounts = (
  currentItem,
  toteAssignments
) => {
  if (!currentItem || !currentItem.product_id || !toteAssignments) {
    return {totalScannedAcrossAllTotes: 0, totalRequiredAcrossAllTotes: 0, allItemPieces: []};
  }
  
  const currentProductId = currentItem.product_id;
  let totalScannedAcrossAllTotes = 0;
  let totalRequiredAcrossAllTotes = 0;
  let allItemPieces = [];
  
  toteAssignments.forEach(assignment => {
    if (assignment.product_id === currentProductId) {
      totalScannedAcrossAllTotes += assignment.item_scanned_qty || 0;
      totalRequiredAcrossAllTotes += assignment.item_qty || 0;
      if (assignment.item_pieces && assignment.item_pieces.length > 0) {
        allItemPieces.push(...assignment.item_pieces);
      }
    }
  });
  return {totalScannedAcrossAllTotes, totalRequiredAcrossAllTotes, allItemPieces: sortItemPieces(allItemPieces)};
};

export const sortItemPieces = (allItemPieces) => {
  const statusOrder = { 'required': 1, 'picked': 2, 'placed': 3 };
  
  return allItemPieces.sort((a, b) => {
    return (statusOrder[a.status] || 999) - (statusOrder[b.status] || 999);
  })?.reverse();
};

export const getProductRemainingCount = (productId, toteAssignments) => {
  if (!productId || !toteAssignments) {
    return 0;
  }

  let totalRequired = 0;
  let totalScanned = 0;

  toteAssignments.forEach(assignment => {
    if (assignment.product_id === productId) {
      totalRequired += assignment.item_qty || 0;
      totalScanned += assignment.item_scanned_qty || 0;
    }
  });

  return totalRequired - totalScanned;
};

//Get location display string
export const getLocationDisplay = currentItem => {
  if (!currentItem) return 'No Item';

  if (currentItem.location && currentItem.location.trim() !== '') {
    return currentItem.location;
  }

  // Fallback to SKU if no location
  return currentItem.sku || 'No SKU';
};

//Get place quantity for current tote
export const getPlaceQuantity = currentTote => {
  if (!currentTote || !currentTote.item_pieces) return 0;

  return currentTote.item_pieces.filter(piece => piece.status === 'picked').length;
};

export const calculateOptimalCirclesPerRow = (totalCircles) => {
  if (totalCircles <= 3) return totalCircles;
  if (totalCircles <= 8) return Math.min(5, totalCircles);
  if (totalCircles <= 15) return 5;
  if (totalCircles <= 24) return 6;
  if (totalCircles <= 35) return 7;
  return 8;
};

export const calculateCircleSize = (totalCircles) => {
  if (totalCircles <= 6) return { size: 16, borderRadius: 8, borderWidth: 2 };
  if (totalCircles <= 12) return { size: 12, borderRadius: 6, borderWidth: 2 };
  if (totalCircles <= 20) return { size: 10, borderRadius: 5, borderWidth: 2 };
  if (totalCircles <= 30) return { size: 8, borderRadius: 4, borderWidth: 1.5 };
  return { size: 6, borderRadius: 3, borderWidth: 1 };
};
